import { render } from "./ChangePasswordForm.vue?vue&type=template&id=232f0a0c"
import script from "./ChangePasswordForm.vue?vue&type=script&lang=js"
export * from "./ChangePasswordForm.vue?vue&type=script&lang=js"

import "./ChangePasswordForm.vue?vue&type=style&index=0&id=232f0a0c&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__